export const MODALS = {
  ADD: 'MODALS_ADD',
  HIDE: 'MODALS_HIDE',
  REMOVE: 'MODALS_REMOVE',
};

export const addModal = (level, messages, title, download, text) =>
  ({ type: MODALS.ADD, level, messages, title, download, text });

export const hideModal = () => ({ type: MODALS.HIDE });

export const removeModal = () => ({ type: MODALS.REMOVE });



// WEBPACK FOOTER //
// ./src/actions/modals.js